const GET_PO_VENDOR_EMAIL = 'GET_PO_VENDOR_EMAIL'
const SET_PO_VENDOR_EMAIL = 'SET_PO_VENDOR_EMAIL'

const GET_SEND_PO_VENDOR_EMAIL = 'GET_SEND_PO_VENDOR_EMAIL'
const SET_SEND_PO_VENDOR_EMAIL = 'SET_SEND_PO_VENDOR_EMAIL'

const SET_EMAIL_ATTACHMENTS = 'SET_EMAIL_ATTACHMENTS';
const UPLOAD_EMAIL_ATTACHMENTS = 'UPLOAD_EMAIL_ATTACHMENTS';
const REMOVE_EMAIL_ATTACHMENT = 'REMOVE_EMAIL_ATTACHMENT';

export {
    GET_PO_VENDOR_EMAIL,
    SET_PO_VENDOR_EMAIL,
    GET_SEND_PO_VENDOR_EMAIL,
    SET_SEND_PO_VENDOR_EMAIL,
    SET_EMAIL_ATTACHMENTS,
    UPLOAD_EMAIL_ATTACHMENTS,
    REMOVE_EMAIL_ATTACHMENT
};